/**
 * The music stage's geometry, shared by the real section and the profile
 * skeleton (a plain module, so a server component can read it too).
 *
 * The stage height is FIXED and pure CSS: container-query units resolve before
 * hydration, never wait for a JS measure, and never change on open/close. That
 * is the whole zero-shift contract — the case moves inside the stage, the
 * stage never moves the page.
 */

/** Closed case edge as a fraction of the column, and its ceiling. */
export const CASE_FRACTION = 0.58;
export const CASE_MAX_PX = 300;
/** Share of the column the open (spread) pair may use. */
export const OPEN_FIT = 0.88;
/** Vertical breathing room for the tilt/perspective, as a fraction of S. */
export const STAGE_PAD = 0.07;

/** Height of the stage, in container units (`containerType: inline-size`). */
export const MUSIC_STAGE_HEIGHT_CSS = `calc(min(${CASE_FRACTION * 100}cqw, ${CASE_MAX_PX}px) * ${1 + STAGE_PAD * 2})`;
/** Edge of the closed case, same units. */
export const MUSIC_CASE_SIZE_CSS = `min(${CASE_FRACTION * 100}cqw, ${CASE_MAX_PX}px)`;
